import Vue from 'vue';
import VueEnv from '@telexpress/vue-env';
import * as config from '@/config';

Vue.use(VueEnv, config);
